function isFuseLenses() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('fuse') !== -1;
}

export default isFuseLenses;
